module.exports = __webpack_public_path__ + "media/header-mobile-kz.1c25bb11.mp4";